// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3ffyd","title":"AfterFrontImage_title__1apP_"};